import * as React from "react";
import {MouseEvent} from "react";
import {prettyPrintLike} from "../../_helpers/utils";
import * as classNames from "classnames";

interface Props {
    likable: Likable;
    toggleLike: (e: MouseEvent<HTMLElement>, id: number) => void;
    isGalleryView?: boolean;
    currentUserID?: number;
}

const LikeComponent = (props: Props) => {
    const {likable, toggleLike, isGalleryView, currentUserID} = props;
    const liked = likable.isLiked;

    const clickableLike = (
        <a onClick={(e) => toggleLike(e, currentUserID)} className={classNames({active: liked})}>
            <i className={classNames("fa fa-fw", {"fa-heart": liked, "fa-heart-o": !liked})}/>
            &nbsp;{prettyPrintLike(likable)}
        </a>
    );

    if (isGalleryView)
        return (
            <p className="text-center featured-image-block-title">
                {clickableLike}
            </p>
        );
    else
        return (
            <li className="mr-2">
                {clickableLike}
            </li>
        );
};
export default LikeComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/like/LikeComponent.tsx